// Shared date-range presets for list toolbars and export dialogs.

export const DATE_PRESETS = [
  { value: 'all', label: 'All time' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_30', label: 'Last 30 days' },
  { value: 'last_90', label: 'Last 90 days' },
  { value: 'this_year', label: 'This year' },
  { value: 'last_year', label: 'Last 1 year' },
  { value: 'custom', label: 'Custom…' },
];

// Local YYYY-MM-DD (not toISOString, which would shift the day in +tz locales).
const ymd = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function rangeForPreset(preset: string): { dateFrom: string; dateTo: string } {
  const now = new Date();
  const to = ymd(now);
  const back = (mut: (d: Date) => void) => { const d = new Date(now); mut(d); return ymd(d); };
  switch (preset) {
    case 'this_month': return { dateFrom: ymd(new Date(now.getFullYear(), now.getMonth(), 1)), dateTo: to };
    case 'last_30': return { dateFrom: back((d) => d.setDate(d.getDate() - 30)), dateTo: to };
    case 'last_90': return { dateFrom: back((d) => d.setDate(d.getDate() - 90)), dateTo: to };
    case 'this_year': return { dateFrom: ymd(new Date(now.getFullYear(), 0, 1)), dateTo: to };
    case 'last_year': return { dateFrom: back((d) => d.setFullYear(d.getFullYear() - 1)), dateTo: to };
    default: return { dateFrom: '', dateTo: '' };
  }
}
